// START_MODULE pages_main_sections_main_styled_ts
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Preserve the original hero layout while the subtitle remains static.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import styled, { css } from 'styled-components';

export const MainSectionWrapper = styled.div`
  position: relative;
  height: 100vh;
`;

export const HeadersWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 80%;
  text-align: center;
  display:flex;
  align-items: center;
  flex-direction: column;

  margin: 0 auto;
`;

export const MainHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;

  margin-bottom: 20px;

  @media (max-width: 1200px) {
    flex-direction: column;
  }
`;

export const MainHeader = styled.h1`
  ${({ theme }) => css`
    color: ${theme.accentColor};
    font-family: ${theme.accentFontFamily};

    font-weight: 500;

    font-size: 5rem;
  `};
`;

export const SubHeader = styled.h3`
  font-size: 2rem;
  font-family: monospace;

  @media (max-width: 450px) {
    font-size: 1.5rem;
  }
`;

export const Logo = styled.img`
  width: 120px;
  height: 120px;
`;

export const LogoText = styled.img`
  height: 75px;
  fill: #000000 !important;
  .cls-1 {
    fill: #000000 !important;
  }

  @media (max-width: 1100px) {
    height: 60px;
  }
  @media (max-width: 850px) {
    height: 40px;
  }
  @media (max-width: 600px) {
    height: 30px;
  }
  @media (max-width: 450px) {
    height: 20px;
  }
`;

export const ArrowDownCircle = styled.div`
  ${({ theme }) => css`
    background-color: white;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 2px solid ${theme.accentColor};

    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    top: 93%;
    left: 50%;
    transform: translateX(-50%);

    >svg {
      color: ${theme.accentColor};
      transition: .2s;
    }

    transition: .2s;
    &:hover {
      >svg {
        transform: scale(1.3);
      }
    }
  `};
`;

// END_MODULE pages_main_sections_main_styled_ts
